export default __webpack_public_path__ + "static/media/DockingStation.256.d88f28b8.png";